import { render, staticRenderFns } from "./KioskLicense.vue?vue&type=template&id=38d7dde6&"
import script from "./KioskLicense.vue?vue&type=script&lang=js&"
export * from "./KioskLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports